import { createContext, useContext, useRef, useCallback, ReactNode } from 'react';

interface ActiveChatContextType {
  setActiveChatId: (chatId: string | null) => void;
  getActiveChatId: () => string | null;
}

const ActiveChatContext = createContext<ActiveChatContextType | null>(null);

export function ActiveChatProvider({ children }: { children: ReactNode }) {
  const activeChatIdRef = useRef<string | null>(null);

  const setActiveChatId = useCallback((chatId: string | null) => {
    activeChatIdRef.current = chatId;
  }, []);

  const getActiveChatId = useCallback(() => {
    return activeChatIdRef.current;
  }, []);

  return (
    <ActiveChatContext.Provider value={{ setActiveChatId, getActiveChatId }}>
      {children}
    </ActiveChatContext.Provider>
  );
}

// Fallback functions for when used outside provider
const noopSetActiveChatId = () => {};
const noopGetActiveChatId = () => null;

export function useActiveChat(): ActiveChatContextType {
  const context = useContext(ActiveChatContext);
  // Return safe fallbacks if used outside provider
  if (!context) {
    return {
      setActiveChatId: noopSetActiveChatId,
      getActiveChatId: noopGetActiveChatId,
    };
  }
  return context;
}
